export default class ForbiddenPortalRequestedException extends Error {
  constructor(message: string) {
    super(message);
  }
}
